var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"concierge-list",class:{ 'transfer-modal' : _vm.isTransferModal }},[_vm._l((_vm.viewableConcierges),function(concierge,index){return _c('li',{key:concierge.agentId,staticClass:"concierge-item"},[_c('ConciergeItem',{ref:"isChannelListShown",refInFor:true,attrs:{"concierge":{
        conciergeId : concierge.agentId
        , realName : concierge.realName
        , languages : concierge.languages
        , profilePhoto : concierge.profilePhoto
        , channels : concierge.channels
      },"isTransferModal":_vm.isTransferModal}})],1)}),(!_vm.viewableConcierges.length)?_c('div',{staticClass:"empty"},[_c('IconWork'),_c('p',[_vm._v("No concierge with active chat.")])],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }